module.exports = __webpack_public_path__ + "img/imagen6.39383ecc.png";